/**
 * **Dopo un gesto su una riga, la pagina resta ferma** — 11 ottobre 2026, chiesto
 * dal proprietario nel collaudo dei filtri di «Compiti»: *«ora funziona solo se la
 * riga è in cima allo schermo; se è nel mezzo torna sulla riga corretta ma in
 * cima allo schermo»*.
 *
 * Il ritorno di «Fatto», «Da ripassare», «Rimetti da fare»… porta l'ancora della
 * riga (`#attivita-…`, `ancoraDellAttivita`), e il browser la mette in cima allo
 * schermo. `TieniLaRiga` ricorda a che altezza dello schermo stava la riga quando
 * si è premuto, e dopo il ritorno la rimette lì. Le regole stanno qui, fuori dal
 * componente, perché in un browser nessun test di questo progetto entra (come
 * `scorrimento.ts`).
 *
 * **Senza codice cliente non manca niente**: resta l'ancora, con la riga in cima
 * sotto la striscia delle sezioni (`scroll-margin-top`).
 */

/** Le righe che un ritorno può nominare con un'ancora: un'attività, o una voce. */
export const RIGHE_CON_ANCORA = '[id^="attivita-"], [id^="voce-"]';

/** Quanto a lungo, dopo il clic, si tiene ferma la riga: la risposta del server più lo scorrimento all'ancora. */
export const ATTESA_MASSIMA_MS = 6000;

/** Quanto si aspetta, dopo l'ultima correzione, prima di smettere di guardare. */
export const QUIETE_MS = 800;

/**
 * **Di quanto scorrere** per rimettere la riga dov'era: la differenza fra dove sta
 * adesso e dove stava, o zero sotto i due punti — un arrotondamento non è uno
 * spostamento, e correggerlo farebbe tremare la pagina.
 */
export function quantoScorrere(altoPrima: number, altoAdesso: number): number {
  const differenza = altoAdesso - altoPrima;
  return Math.abs(differenza) < 2 ? 0 : differenza;
}
